module.exports = __webpack_public_path__ + "fonts/iconfont.a039020.woff2";